export default "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAyAAAAAFAQMAAACHNxozAAAAA1BMVEXR0dFCxnTBAAAADUlEQVQY02MYBSMTAAAB+QABZGhUcQAAAABJRU5ErkJggg=="